import { render, staticRenderFns } from "./PMNAdministration.vue?vue&type=template&id=27f8a9b2&scoped=true&"
import script from "./PMNAdministration.vue?vue&type=script&lang=ts&"
export * from "./PMNAdministration.vue?vue&type=script&lang=ts&"
import style0 from "./PMNAdministration.vue?vue&type=style&index=0&id=27f8a9b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f8a9b2",
  null
  
)

export default component.exports